import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { ComponentVisibilityService } from 'src/app/services/commonService/component-visibility.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ContentService } from '../../services/content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { DatePipe, NgIf, NgSwitch, NgSwitchCase, NgClass, TitleCasePipe } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { DependentDatalayerService } from 'src/app/services/dataLayer/CAM/dependent.service';
import { WaitingComponent } from 'src/app/shared/components/waiting/waiting.component';
export const passportDatesValidator: ValidatorFn = (
  group: AbstractControl
): ValidationErrors | null => {
  const validFrom = group.get('passportvalidFrom')?.value;
  const expiry = group.get('passportExpiry')?.value;

  if (validFrom && expiry) {
    const fromDate = new Date(validFrom);
    const expiryDate = new Date(expiry);

    if (fromDate.getTime() === expiryDate.getTime()) {
      // return { invalidExpiry: true };
      group
        .get('passportvalidFrom')
        ?.setErrors({
          ...(group.get('passportvalidFrom')?.errors || {}),
          invalidExpiry: true,
        });
      group
        .get('passportExpiry')
        ?.setErrors({
          ...(group.get('passportExpiry')?.errors || {}),
          invalidExpiry: true,
        });
    }
  }

  return null;
};
@Component({
    selector: 'app-dependents-form',
    templateUrl: './dependents-form.component.html',
    styleUrls: ['./dependents-form.component.scss'],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        NgIf,
        MatIcon,
        NgSwitch,
        NgSwitchCase,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        NgClass,
        MatButton,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        CamEmptyStateComponent,
        TitleCasePipe,
      WaitingComponent
    ],
})
export class DependentsFormComponent implements OnInit  {
  displayedColumns: string[] = [
    'Name',
    'Relation',
    'Email',
    'MobileNumber',
    'Status',
    'Actions',
  ];
  isDisableDateOfBirth = false;
  guid: any;
  userid: any;
  dataSource1:any = new MatTableDataSource([]);
  dateRanges: Record<string, { minDate: Date; maxDate: Date }> = {};
  selectedDOB: Date | null = null;
  countriesLists: any;
  paxTitles: any[] = [];
  GCCID: boolean = false;
  @Input() PPREQ?: boolean;
  @Input() PPEXPREQ?: boolean;
  @Input() NTLREQ?: boolean;
  @Input() ISUCONTREQ?: boolean;
  @Input() Nationality: string | null = null;
  @Input() Country: string | null = null;
  private destroy$ = new Subject<void>();
  userDeactivateModellRef!: MatDialogRef<TemplateRef<any>>;
  @Output() fieldStatusChange: EventEmitter<any> = new EventEmitter(); // Emit the field status
  dataRange = {
    CHD: { min: 12, max: 2 },
    INS: { min: 2, max: 0 },
    INF: { min: 2, max: 0 },
    ADT: { min: 12, max: 83 },
  };
  commonObj: any = {
    nationalID: null,
  };
  commonObjPipes: any = {
    countryControl: { pipe: [], all: [] },
    countryCode: { pipe: [{ id: 1, name: '' }], all: [] },
    mealPref: { pipe: [], all: [] },
    seatingPref: { pipe: [], all: [] },
    shorthaulSeatingPref: { pipe: [], all: [] },
    prefStopover: { pipe: [], all: [] },
    prefMaxLayout: { pipe: [], all: [] },
    prefClass: { pipe: [], all: [] },
    prefAirline: { pipe: [], all: [] },
    airlineCode: { pipe: [], all: [] },
    otherPref: { pipe: [], all: [] },
    cities: [],
  };
  selectedExpiryDate: Date | string | null = new Date();
  departureDate: any;
  minDate: any = { year: null, month: null, date: null };
  maxDate: any = { year: null, month: null, date: null };
  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false,
    isValidFromCalendarVisible: false,
    isVisibleCalendar: false,
    isVisibleExpiryCalendar: false,
  };
  newDate: Date = new Date();
  Loader: any = {
    isSpinner: false,
    isAddNew: false,
    isLists: false,
    isEditableClicked: false,
    STATE: 'EMPTY',
  };
  userRole:string='1';
  noDataPersonalInfo!: boolean;
  content: any;
  pageSize = 20;
currentPage = 0;
filteredData: any[] = [];
paginatedData: any[] = [];
totalPages = 0;
  constructor(
    private  readonly fb: FormBuilder,
    public visibilityService: ComponentVisibilityService,
    private readonly _CamApiService: CamService,
    public _ApiService: ApiService,
    public _CommonService: CommonService,
    public _CryptoService: CryptoService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly _ActivatedRoute: ActivatedRoute,
    private readonly contentService: ContentService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly crypto:CryptoService,
    private readonly router:Router,
    private readonly travelerManagement:TravelerManagement,
    private readonly datePipe:DatePipe,
    private readonly _CamService:CamService,
    private readonly _MatDialog: MatDialog,
    private readonly _DependentDatalayerService:DependentDatalayerService,
  ) {}
  handleEvent(event: string) {
    // GTM Event Call
      const noOfResult = this.dataSource1?.data?.length || 0;
      this.travelerManagement.traveler_dependents_detail_click( 'Add', noOfResult,'Add' );
      this.travelerManagement.family_management_click(noOfResult,'Add Dependent');
      this._DependentDatalayerService.underDependentAddNewDependent('Add new','Add',noOfResult);
    if (event.includes('dependent-form')) {
      this.Loader.isAddNew = true;
      this.Loader.STATE = 'FORM';
    }
  }
  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$,
      dictionary: this.dictionaryContentService.content$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = {
          ...res.content,
          dictionary: res.dictionary,
        };
      });
    this.userRole = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string;
    this.guid = this._ApiService.getSession('guid') as string;
    this.userid = this._ApiService.getSession('userId') as string;
    this.getDependentLists();
    this._ApiService
      .getCountriesData()
      .then(($res) => {
        this.countriesLists = this._CommonService.groupCountriesFilter($res);
      })
      .catch(($err) => {});
    this._CamApiService
      .GetPaxTittle()
      .then((response: any) => {
        if (response?.status === 'Success') {
          this.paxTitles = response.data || [];
        }
      })
      .catch((error: any) => {
        console.error('Error fetching Pax Titles:', error);
      });
    this.onDepartureDateChange(this.selectedExpiryDate);
    this.noDataPersonalInfo = this._CommonService.getData('camSidebar');
  }
  getDependentLists() {
    this.Loader.STATE = 'WAITING'
    const formParam = this._ActivatedRoute.snapshot.queryParamMap.get('form');
    if (formParam == 'open') {
      this.Loader.STATE = 'LIST';
    }
    this._CamApiService
      .getDependentList()
      .then((response: any) => {
        console.log('dependent list ',response);
        this.dataSource1.data = response?.data || [];
        this.filteredData = response?.data || [];
        const savedPage = sessionStorage.getItem('returnPage');
        if(savedPage !== null){
          this.currentPage = Number(savedPage);
          // one-time use
          sessionStorage.removeItem('returnPage');
        }
        else{
          this.currentPage = 0;
        }
        this.updatePagination();
this.updatePagination();
          this.Loader.isLists = !!response?.data.length;
          this.Loader.isAddNew = true;
          this.Loader.STATE = !formParam
            ? this.Loader.isLists
              ? 'LIST'
              : 'EMPTY'
            : this.Loader.STATE;
      })
      .catch((error: any) => {
        this.Loader.STATE = 'LIST'
        console.error('Error fetching Pax Titles:', error);
      });
  }
  DateTypeReturn(date: string): Date {
    return new Date(date);
  }
  createLoyaltyProgram(data: any): FormGroup {
    return this.fb.group({
      isPrimary: data?.isPrimary ?? data?.Is_Primary ?? false,
      saUserId: [this._ApiService.getSession('userId')],
      airlineCode: [data?.airlineCode ?? data?.AirlineCode],
      loyaltyNumber: [data?.loyaltyNumber ?? data?.LoyaltyNumber],
      loyaltyExpiryDate: (
        data?.loyaltyExpiryDate ?? data?.LoyaltyExpiryDate
      )?.match(/\//)?.length
        ? this._CommonService.postFormatDate(
            data?.loyaltyExpiryDate ?? data?.LoyaltyExpiryDate
          )
        : (data?.loyaltyExpiryDate ?? data.LoyaltyExpiryDate).split('T')[0] ??
          null,
      isInternationalFlight:
        data?.isInternationalFlight ?? data?.IsInternationalFlight,
      LoyaltyProgramID: data?.LoyaltyProgramID ?? 0,
      isActive: data?.isActive ?? data?.IsActive ?? true,
    });
  }

  Cancel() {
    this._CommonService.formResetTrigger();
    this.Loader.isEditableClicked = false;
    this.Loader.isAddNew = false;
    this.Loader.STATE = this.Loader.isLists ? 'LIST' : 'EMPTY';
  }
  editDependent(element:any){
    const statusText = element?.status === '1' ? 'Active' : element?.status === '2' ? 'Invite sent' : '';
    const noOfResult = this.dataSource1?.data?.length || 0;
    sessionStorage.setItem('dptState','4');
    this.travelerManagement.traveler_dependents_detail_click('Edit',noOfResult,'Edit');
    this._DependentDatalayerService.dependentActionEdit('Edit',statusText,element?.relation);
  this.router.navigate(['/cam/saved-dependents/dependent-information-form'],{
    queryParams: {
      dependentId: element?.dependantId,
      userId:element?.b2bUserId
    }
  })
  }
  viewDetail(element:any){
    sessionStorage.setItem(
      'returnPage',
      this.currentPage.toString()
    );
    // GTM Event Call
    const noOfResult = this.dataSource1?.data?.length || 0;
    this.travelerManagement.traveler_dependents_detail_click( 'Resend Invite', noOfResult,'Resend' );
    sessionStorage.setItem('dptState','2');
    this.router.navigate(['/cam/saved-dependents/dependent-information-form'],{
      queryParams: {
        dependentId: element?.dependantId,
        userId:element?.b2bUserId
      }
    })
  }



 async   resendInvite(dependent:any){
   // GTM Event Call
   const statusText = dependent?.status === '1' ? 'Active' : dependent?.status === '2' ? 'Invite sent' : '';
  const noOfResult = this.dataSource1?.data?.length || 0;
  this.travelerManagement.traveler_dependents_detail_click( 'Resend', noOfResult,'Resend' );
  this.travelerManagement.family_management_click(noOfResult,'Resend Invite');
  this._DependentDatalayerService.dependentRequestResend('Resend',statusText,dependent?.relation);
  const payload={
    dependantId:dependent?.dependantId,
    b2bId:dependent?.b2bUserId,
    }
    this._CamService.getDependentDetails(payload).then(async(res:any)=>{
      let token:string='';
      const  payload1={
        email: dependent?.email,
        b2bUserGuid:res?.data[0]?.dependantdata[0]?.GUID
        }
        try {
          const response = await this._CamService.generateDependentToken(payload1);
          if (response?.status === 'Created' || response?.status === 'Success') {
            this._ToastrApiService.show(
              'success',
             'Invite sent again to the dependent successfully.'
            );
            // token = response?.data;
          } else {
            this._ToastrApiService.show(
              'error',
              response?.message || 'Failed to resent invite.'
            );
          }
        } catch (error: any) {
          const message =
            error?.error?.message || error?.message ||
            'Something went wrong while creating token. Please try again.';
          this._ToastrApiService.show('error', message);
        } 
    },(error:any)=>{
      this._ToastrApiService.show('error','Something went wrong!');
    });

  }
  filterCountries(value: any): void {
    const searchValue = (value || '').toString().toLowerCase();
  
    const currentState: any[] = this.countriesLists?.filter(
      ($country: any) =>
        $country.countryName
          ?.toLowerCase()
          .includes(searchValue)
    );
  
    // this.groupCountries(currentState);
  }
  _filterCommon(type: string, value: string, key: string): any[] {
    const filterValue = value.toLowerCase();
    return this.commonObjPipes[type].all.filter((meal: any) =>
      meal[key].toLowerCase().includes(filterValue)
    );
  }
  filterControls(type: string, event: any, key: string) {
    event = event?.target?.value ?? event.value;
    this.commonObjPipes[type].pipe = this._filterCommon(type, event || '', key);
  }
  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  addEdit(isAdd: boolean) {
    if (isAdd) {
      this.Loader.isAddNew = true;
      this.Loader.isEditableClicked = false;
      this.Loader.STATE = 'FORM';
    }
  }

  blockInvalidCharactersForDOB(event: KeyboardEvent): void {
    const allowedKeys = /^[0-9\-\/]$/;
    if (!allowedKeys.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }
  pasteControlHTMLTags(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text/plain') || '';
    if (!/^ [0 - 9\-\/]+$/.test(pastedData)) {
      event.preventDefault();
    }
  }
  onConfirm(componentKey: string) {
    this.hideComponent(componentKey);
  }
  hideComponent(componentKey: string): void {
    this.isChildVisible[componentKey] = false;
  }
  private initializeDateRanges(): void {
    this.dateRanges = Object.fromEntries(
      Object.entries(this.dataRange).map(([key, range]) => [
        key,
        {
          minDate: this.calculateDate(range.min),
          maxDate: this.calculateDate(range.max),
        },
      ])
    );
  }
  private calculateDate(yearsFromNow: number): Date {
    const today = new Date();
    return new Date(
      today.getFullYear() - yearsFromNow,
      today.getMonth(),
      today.getDate()
    );
  }
  onDepartureDateChange(departureDate: Date | string | null): void {
    this.departureDate = departureDate;
    this.setMinDateRange();
    this.setMaxDateRange();
  }

  setMinDateRange() {
    let departureDate = new Date(this.departureDate);
    let year = departureDate.getFullYear();
    let month = departureDate.getMonth();
    let date = departureDate.getDate();
    this.minDate = { year, month, date };
  }

  setMaxDateRange() {
    let minDate = new Date(
      this.minDate.year,
      this.minDate.month,
      this.minDate.date
    );
    minDate.setFullYear(minDate.getFullYear() + 47);
    let year = minDate.getFullYear();
    let month = minDate.getMonth();
    let date = minDate.getDate();
    this.maxDate = { year, month, date };
  }
  formatTitleName(fullName: string): string {
    if (!fullName) return '';
    const parts = fullName.trim().split(/\s+/);
    if (parts.length > 1) {
      parts[0] = parts[0].replace(/\.+$/, '') + '.'; // Add exactly one dot to first word (title)
      return parts.join(' ');
    }
    return fullName;
  }
  viewInvite(dependent:any,index: number){
    const statusText = dependent?.status === '1' ? 'Active' : dependent?.status === '2' ? 'Invite sent' : '';
    const noOfResult = this.dataSource1?.data?.length || 0;
    this.travelerManagement.traveler_dependents_detail_click('CTA',noOfResult,'View');
    this._DependentDatalayerService.dependentSelect(`dependent_${index + 1}`,statusText,dependent?.relation);
    sessionStorage.setItem(
      'returnPage',
      this.currentPage.toString()
    );
    sessionStorage.setItem('dptState','2');
    this.router.navigate(['/cam/saved-dependents/dependent-information-form'],{ queryParams: {
      dependentId: dependent?.dependantId,
      userId:dependent?.b2bUserId
    }});
    
  }
  blockInvalidCharacters(event: KeyboardEvent): void {
    const invalidChars = [
      '<',
      '>',
      '"',
      "'",
      '`',
      ';',
      '--',
      '\\',
      '?',
      '+',
      '_',
      '#',
      '%',
      '^',
      '*',
      '!',
      '=',
      '%',
      '(',
      ')',
      '{',
      '}',
      '$',
      '~',
      '@',
      '&',
    ];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }
  navigateToForm(){
    // GTM Event Call
    const noOfResult = this.dataSource1?.data?.length || 0;
    this.travelerManagement.family_management_click(noOfResult,'Resend Invite');
    this.travelerManagement.traveler_dependents_detail_click('Add',noOfResult,'Add new dependent');
    this._DependentDatalayerService.underDependentAddNewDependent('Add new dependent','Add new dependent',noOfResult);
    sessionStorage.setItem('dptState','1');
    this.router.navigate(['/cam/saved-dependents/dependent-information-form'])
  }
  updatePagination() {
    this.totalPages = Math.ceil(this.filteredData.length / this.pageSize);
  
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
  
    this.paginatedData = this.filteredData.slice(start, end);
  
    this.dataSource1.data = this.paginatedData; // table bind yahi se hoga
  }
  
  nextPage() {
    if (this.currentPage + 1 < this.totalPages) {
      this.currentPage++;
      sessionStorage.setItem('dependentPage', this.currentPage.toString());
      this.updatePagination();
    }
  }
  
  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      sessionStorage.setItem('dependentPage', this.currentPage.toString());
      this.updatePagination();
    }
  }
  openModal(template: TemplateRef<any>,depandant:any) {
    const statusText = depandant?.status === '1' ? 'Active' : depandant?.status === '2' ? 'Invite sent' : '';
    const noOfResult = this.dataSource1?.data?.length || 0;
    this.travelerManagement.traveler_dependents_detail_click('Remove', noOfResult,'Remove');
    this._DependentDatalayerService.dependentActionDelete('Delete',statusText,depandant?.relation);
    this.userDeactivateModellRef = this._MatDialog.open(template, {
      panelClass: ['custom-popup-gen-policy-filter-popup', 'traveler-deactivate-popup'],
      disableClose: false,
      autoFocus: false,
    });
  }

  callByGtm(){
    this.travelerManagement.dependent_remove( 'Cancel','Cancel' );
  }
  DeleteDependent(depandant: any) {
    // GTM Event Call
    const noOfResult = this.dataSource1?.data?.length || 0;
    this.travelerManagement.dependent_remove( 'Deactivate','Deactivate');
    const payload = {
      "userId": this.userid,
      "dependentId": (depandant.dependantId).toString()    
    };
    this._CamApiService
      .deleteDependent(payload)
      .then(($res: any) => {
        sessionStorage.setItem(
          'returnPage',
          this.currentPage.toString()
        );
        this.getDependentLists();
        this.travelerManagement.dependent_remove_success('Deactivate','Success');
        this._ToastrApiService.show('error', 'Dependent has been deactivated successfully.');
        this.userDeactivateModellRef.close();
      })
      .catch((error) => {
        this._ToastrApiService.show('error', error.error.message);
      });
  }
}
